import React from "react";
import classNames from 'classnames';

const inputUrl = ({
  label,
  onChange,
  value,
  placeholder,
  description,
  error = null
}) => {

  const classes = classNames(
    'form-control',
    'fantastic-form-control',
    {
      'shake-it': !!error
    }
  );
  return (
    <div className="form-group">
     {label && <label>{label}</label>}
      <input
        type="text"
        className={classes}
        placeholder={placeholder}
        onChange={e => onChange(e.target.value)}
        value={value}
      />
      {error && (
        <small className="form-text text-danger">{error}</small>
      )}
      {description && (
        <small className="form-text text-muted">{description}</small>
      )}
    </div>
  );
};

export default inputUrl;
